import { render, staticRenderFns } from "./TestTableSelection.vue?vue&type=template&id=cf5ab67e&scoped=true&"
import script from "./TestTableSelection.vue?vue&type=script&lang=js&"
export * from "./TestTableSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ab67e",
  null
  
)

export default component.exports